import React, {FC} from 'react';

import modelAiWrite1 from 'assets/v3/guide/model/ai-write-1.webp';
import modelAiWrite2 from 'assets/v3/guide/model/ai-write-2.webp';
import modelEntry from 'assets/v3/guide/model/entry.webp';
import modelRegen from 'assets/v3/guide/model/regen.webp';
import modelShowClothes1 from 'assets/v3/guide/model/show-clothes-1.webp';
import modelShowClothes2 from 'assets/v3/guide/model/show-clothes-2.webp';
import modelShowCup1 from 'assets/v3/guide/model/show-cup-1.webp';
import modelShowCup2 from 'assets/v3/guide/model/show-cup-2.webp';
import modelShowEarring1 from 'assets/v3/guide/model/show-earring-1.webp';
import modelShowEarring2 from 'assets/v3/guide/model/show-earring-2.webp';
import modelShowLamp1 from 'assets/v3/guide/model/show-lamp-1.webp';
import modelShowLamp2 from 'assets/v3/guide/model/show-lamp-2.webp';
import modelShowNecklace1 from 'assets/v3/guide/model/show-necklace-1.webp';
import modelShowNecklace2 from 'assets/v3/guide/model/show-necklace-2.webp';
import modelShowPruner1 from 'assets/v3/guide/model/show-pruner-1.webp';
import modelShowPruner2 from 'assets/v3/guide/model/show-pruner-2.webp';
import modelUploadFront from 'assets/v3/guide/model/upload-front.webp';
import modelUploadScene from 'assets/v3/guide/model/upload-scene.webp';
import sceneAiWrite1 from 'assets/v3/guide/scene/ai-write-1.webp';
import sceneAiWrite2 from 'assets/v3/guide/scene/ai-write-2.webp';
import sceneEntry from 'assets/v3/guide/scene/entry.webp';
import sceneRegen from 'assets/v3/guide/scene/regen.webp';
import sceneShowEarphone1 from 'assets/v3/guide/scene/show-earphone-1.webp';
import sceneShowEarphone2 from 'assets/v3/guide/scene/show-earphone-2.webp';
import sceneShowFeeder1 from 'assets/v3/guide/scene/show-feeder-1.webp';
import sceneShowFeeder2 from 'assets/v3/guide/scene/show-feeder-2.webp';
import sceneShowNecklace1 from 'assets/v3/guide/scene/show-necklace-1.webp';
import sceneShowNecklace2 from 'assets/v3/guide/scene/show-necklace-2.webp';
import sceneShowOil1 from 'assets/v3/guide/scene/show-oil-1.webp';
import sceneShowOil2 from 'assets/v3/guide/scene/show-oil-2.webp';
import sceneShowPerfume1 from 'assets/v3/guide/scene/show-perfume-1.webp';
import sceneShowPerfume2 from 'assets/v3/guide/scene/show-perfume-2.webp';
import sceneShowPruner1 from 'assets/v3/guide/scene/show-pruner-1.webp';
import sceneShowPruner2 from 'assets/v3/guide/scene/show-pruner-2.webp';
import sceneShowUmbrella1 from 'assets/v3/guide/scene/show-umbrella-1.webp';
import sceneShowUmbrella2 from 'assets/v3/guide/scene/show-umbrella-2.webp';
import sceneUploadSample from 'assets/v3/guide/scene/upload-sample.webp';

/** 사용 가이드 「모델/씬 이미지」 탭 한국어 본문(zh.tsx와 요소 구조 1:1) — 2026-09-17 AI 번역 */
const KoContent: FC = () => {
  return (
    <>
      <h2>상품 씬 이미지 생성</h2>

      <h3>1. 씬 이미지 생성하기</h3>
      <img alt="씬 생성 진입 화면" decoding="async" loading="lazy" src={sceneEntry} />
      <p>상품 사진 1~3장을 업로드해요. 완전하고 다양한 사진일수록 더 정확하고 좋은 상품 씬 이미지를 만들 수 있어요.</p>
      <img alt="상품 업로드 예시" decoding="async" loading="lazy" src={sceneUploadSample} />
      <p>
        씬 연출에 대한 구체적인 요구가 있다면 “+ 텍스트 설명 입력(선택)”을 클릭해 내용을 입력하세요. 특별한 요구가
        없다면 AI에 맡겨도 좋아요.
      </p>
      <p>설명을 작성할 때는 다음 사항을 유의하세요:</p>
      <ul>
        <li>
          “실내”처럼 막연한 표현보다는 구체적인 장면을 묘사해 주세요. 상품을 어떤 장면에 놓고 싶은지 상상한 그대로 적어
          보세요. 예: 거실 커피 테이블 위에 상품이 놓여 있고, 앞쪽에는 꽃이 있으며 옆에는 물컵이 놓인 장면.
        </li>
        <li>
          씬 이미지에는 상품과 사람이 함께하는 장면이 무작위로 생성될 수 있어요. 사람이 나오지 않기를 원한다면 설명에
          “이미지에 사람이 등장하지 않게 해주세요”라고 추가하세요.
        </li>
      </ul>
      <p>모델, 화면 비율, 해상도, 생성 장수를 선택한 뒤 【지금 생성】 버튼을 클릭하면 끝이에요.</p>

      <h3>2. 다시 생성</h3>
      <p>
        씬 이미지가 더 필요하다면 같은 페이지에서 【다시 생성】 버튼을 클릭하기만 하면 돼요. 구체적인 씬 요구가 있다면
        “+ 텍스트 설명 입력”을 클릭해 주세요.
      </p>
      <img alt="다시 생성" decoding="async" loading="lazy" src={sceneRegen} />
      <p>아이디어가 떠오르지 않나요? AI 작성을 이용해 본 뒤 AI 프롬프트를 수정하고 다시 생성해 보세요.</p>
      <img alt="AI 작성" decoding="async" loading="lazy" src={sceneAiWrite1} />
      <img alt="AI 프롬프트 수정 후 재생성" decoding="async" loading="lazy" src={sceneAiWrite2} />

      <h3>3. 쇼케이스</h3>
      <h4>전정가위</h4>
      <figure className="v3-img-pair">
        <img alt="전정가위 씬 1" decoding="async" loading="lazy" src={sceneShowPruner1} />
        <img alt="전정가위 씬 2" decoding="async" loading="lazy" src={sceneShowPruner2} />
      </figure>
      <h4>향수</h4>
      <figure className="v3-img-pair">
        <img alt="향수 씬 1" decoding="async" loading="lazy" src={sceneShowPerfume1} />
        <img alt="향수 씬 2" decoding="async" loading="lazy" src={sceneShowPerfume2} />
      </figure>
      <h4>이어폰</h4>
      <figure className="v3-img-pair">
        <img alt="이어폰 씬 1" decoding="async" loading="lazy" src={sceneShowEarphone1} />
        <img alt="이어폰 씬 2" decoding="async" loading="lazy" src={sceneShowEarphone2} />
      </figure>
      <h4>우산</h4>
      <figure className="v3-img-pair">
        <img alt="우산 씬 1" decoding="async" loading="lazy" src={sceneShowUmbrella1} />
        <img alt="우산 씬 2" decoding="async" loading="lazy" src={sceneShowUmbrella2} />
      </figure>
      <h4>펫 급식기</h4>
      <figure className="v3-img-pair">
        <img alt="펫 급식기 씬 1" decoding="async" loading="lazy" src={sceneShowFeeder1} />
        <img alt="펫 급식기 씬 2" decoding="async" loading="lazy" src={sceneShowFeeder2} />
      </figure>
      <h4>목걸이</h4>
      <figure className="v3-img-pair">
        <img alt="목걸이 씬 1" decoding="async" loading="lazy" src={sceneShowNecklace1} />
        <img alt="목걸이 씬 2" decoding="async" loading="lazy" src={sceneShowNecklace2} />
      </figure>
      <h4>에센셜 오일</h4>
      <figure className="v3-img-pair">
        <img alt="에센셜 오일 씬 1" decoding="async" loading="lazy" src={sceneShowOil1} />
        <img alt="에센셜 오일 씬 2" decoding="async" loading="lazy" src={sceneShowOil2} />
      </figure>

      <h2>상품 모델 이미지 생성</h2>

      <h3>1. 모델 이미지 생성하기</h3>
      <img alt="모델 생성 진입 화면" decoding="async" loading="lazy" src={modelEntry} />
      <p>
        상품 사진 1~3장을 업로드해요. 완전하고 다양한 사진일수록 더 정확하고 좋은 모델 쇼케이스 이미지를 만들 수 있어요.
        상품은 정면과 뒷면 사진을 함께 올리는 것이 가장 좋아요. 예:
      </p>
      <img alt="정면 업로드 예시" decoding="async" loading="lazy" src={modelUploadFront} />
      <p>정면 사진</p>
      <img alt="AI 씬 예시" decoding="async" loading="lazy" src={modelUploadScene} />
      <p>AI 씬 이미지</p>
      <p>
        모델에 대한 구체적인 요구가 있다면 “+ 텍스트 설명 입력(선택)”을 클릭해 내용을 입력하세요. 특별한 요구가 없다면
        AI에 맡겨도 좋아요.
      </p>
      <p>설명을 작성할 때는 원하는 모델을 구체적으로 적어 주세요:</p>
      <ul>
        <li>성별</li>
        <li>나이 또는 연령대(청년 / 중년 / 노년, 또는 특정 나이)</li>
        <li>인종·피부톤(예: 아시아인, 백인, 흑인, 라틴계 등)</li>
        <li>기타(표정, 헤어스타일 등)</li>
      </ul>
      <p>
        모델이 등장할 장면을 직접 지정할 때도 “실내”처럼 막연한 표현은 피하세요. 예를 들어 미국 빈티지 침실처럼
        구체적으로 적어 주세요.
      </p>
      <p>설명 예시: 20세 여성, 백인, 곱슬머리, 미국 빈티지 침실.</p>
      <p>모델, 화면 비율, 해상도, 생성 장수를 선택한 뒤 【지금 생성】 버튼을 클릭하면 끝이에요.</p>

      <h3>2. 다시 생성</h3>
      <p>
        모델 이미지가 더 필요하다면 생성 페이지에서 【다시 생성】 버튼을 클릭하기만 하면 돼요. 구체적인 씬 요구가 있다면
        “+ 텍스트 설명 입력(선택)”을 클릭해 주세요.
      </p>
      <img alt="다시 생성" decoding="async" loading="lazy" src={modelRegen} />
      <p>아이디어가 떠오르지 않나요? AI 작성을 이용해 본 뒤 AI 프롬프트를 수정하고 다시 생성해 보세요.</p>
      <img alt="AI 작성" decoding="async" loading="lazy" src={modelAiWrite1} />
      <img alt="AI 프롬프트 수정 후 재생성" decoding="async" loading="lazy" src={modelAiWrite2} />

      <h3>3. 쇼케이스</h3>
      <h4>의류</h4>
      <figure className="v3-img-pair">
        <img alt="의류 모델 쇼케이스 1" decoding="async" loading="lazy" src={modelShowClothes1} />
        <img alt="의류 모델 쇼케이스 2" decoding="async" loading="lazy" src={modelShowClothes2} />
      </figure>
      <h4>컵</h4>
      <figure className="v3-img-pair">
        <img alt="컵 모델 쇼케이스 1" decoding="async" loading="lazy" src={modelShowCup1} />
        <img alt="컵 모델 쇼케이스 2" decoding="async" loading="lazy" src={modelShowCup2} />
      </figure>
      <h4>목걸이</h4>
      <figure className="v3-img-pair">
        <img alt="목걸이 모델 쇼케이스 1" decoding="async" loading="lazy" src={modelShowNecklace1} />
        <img alt="목걸이 모델 쇼케이스 2" decoding="async" loading="lazy" src={modelShowNecklace2} />
      </figure>
      <h4>테이블 조명</h4>
      <figure className="v3-img-pair">
        <img alt="테이블 조명 모델 쇼케이스 1" decoding="async" loading="lazy" src={modelShowLamp1} />
        <img alt="테이블 조명 모델 쇼케이스 2" decoding="async" loading="lazy" src={modelShowLamp2} />
      </figure>
      <h4>전정가위</h4>
      <figure className="v3-img-pair">
        <img alt="전정가위 모델 쇼케이스 1" decoding="async" loading="lazy" src={modelShowPruner1} />
        <img alt="전정가위 모델 쇼케이스 2" decoding="async" loading="lazy" src={modelShowPruner2} />
      </figure>
      <h4>귀걸이</h4>
      <figure className="v3-img-pair">
        <img alt="귀걸이 모델 쇼케이스 1" decoding="async" loading="lazy" src={modelShowEarring1} />
        <img alt="귀걸이 모델 쇼케이스 2" decoding="async" loading="lazy" src={modelShowEarring2} />
      </figure>
    </>
  );
};

export default KoContent;
